import { memo } from 'react';

import { AccountProvisionBanner } from '~/components/AccountProvisioner/components/AccountProvisionBanner';
import { AnnouncementGlobalBanner } from '~/components/announcements/AnnouncementGlobalBanner';
import { MaintenanceModeBanner } from '~/components/Banners/MaintenanceModeBanner';
import { MobileAppBanner } from '~/components/Banners/MobileAppBanner/MobileAppBanner';
import { PendingEmailBanner } from '~/components/Banners/PendingEmailBanner';
import { CreditUsageBannerAlert } from '~/components/CreditUsageBannerAlert';
import { StripeSubscriptionStatusBanner } from '~/components/SubscriptionStatusBanner';
import { WorkspaceStorageStatusBanner } from '~/components/WorkspaceStorageStatusBanner';
import { viewingCheckoutPageSelector } from '~/store/router/selectors';
import { useAirSelector } from '~/utils/ReduxUtils';

export const Banners = memo(() => {
  const isOnCheckoutPage = useAirSelector(viewingCheckoutPageSelector);

  if (isOnCheckoutPage) {
    // Global announcements cover every page; only the account and billing banners stay off Checkout.
    return <AnnouncementGlobalBanner />;
  }

  return (
    <>
      <MobileAppBanner />
      <StripeSubscriptionStatusBanner />
      <WorkspaceStorageStatusBanner />
      <CreditUsageBannerAlert />
      <PendingEmailBanner />
      <AnnouncementGlobalBanner />
      <MaintenanceModeBanner />
      <AccountProvisionBanner />
    </>
  );
});

Banners.displayName = 'Banners';
